import { render, staticRenderFns } from "./configureKiosk.vue?vue&type=template&id=1d87d901"
import script from "./configureKiosk.vue?vue&type=script&lang=js"
export * from "./configureKiosk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports